<button [className]="cssClass" mat-button color="primary" [matMenuTriggerFor]="languageMenu" matTooltip="{{ 'Common.Language' | translate }}">
  <span class="d-md-inline align-middle">{{ (currentLanguage$ | async)?.languageCode | slice:0:2 | uppercase }} <mat-icon class="align-middle">arrow_drop_down</mat-icon></span>
</button>

<mat-menu #languageMenu>
  <div>
    @for (language of languages; track language) {
      <button mat-menu-item type="button" (click)="changeLanguage(language.languageCode)"
        [ngClass]="{ active: (currentLanguage$ | async)?.languageCode == language.languageCode }">
        {{ language.languageCode | slice:0:2 | uppercase }}
      </button>
    }
  </div>
</mat-menu>
